export default __webpack_public_path__ + "static/media/bank2.4e198316.svg";